export default __webpack_public_path__ + "static/media/eye_open.d0e6e503.svg";